var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submenu-page',{attrs:{"eyebrow":"STUDENT PORTAL","title":"Report","description":"Review report cards and results from mock examinations.","count-label":"report tools"}},[_c('Submenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }